import { render, staticRenderFns } from "./freightEdit.vue?vue&type=template&id=30020876&scoped=true"
import script from "./freightEdit.vue?vue&type=script&lang=ts"
export * from "./freightEdit.vue?vue&type=script&lang=ts"
import style0 from "./freightEdit.vue?vue&type=style&index=0&id=30020876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30020876",
  null
  
)

export default component.exports